import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Tasks, Task, CreateTask, UpdateTask } from "./pages";

export const TasksRouter = [
  <Route
    path="/tasks"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Tasks />
      </ProtectedRoute>
    }
  />,

  <Route path="/task">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateTask />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Task />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateTask />
        </ProtectedRoute>
      }
    />
  </Route>,
];
